export const dateToLocaleTimeDateString = (dateString) => {
    const date = new Date(dateString);
    return `${date.toLocaleTimeString('en-GB', {timeZone: 'UTC'})} - ${date.toLocaleDateString('en-GB')}`;
};

export const dateToTimeDateString = (dateString) => {
    const date = new Date(dateString);
    return `${date.toLocaleTimeString()} - ${date.toLocaleDateString('en-GB')}`;
};
